<script setup lang="ts">
import { PhMoon, PhSun } from '@phosphor-icons/vue'
import { useAppStore } from '@/stores/app.store'
import { computed } from 'vue'
import ButtonNavbar from '@/components/button/ButtonNavbar.vue'

const { toggleTheme } = useAppStore()

const isDarkMode = computed(() => useAppStore().isDarkMode)
</script>

<template>
  <button-navbar @click="toggleTheme" class="min-w-10">
    <!-- Moon Icon -->
    <ph-moon
      v-show="isDarkMode"
      class="absolute m-auto text-yellow-200 inset-0 transition-all duration-150 ease-in-out"
      :class="isDarkMode ? 'opacity-100 scale-100 rotate-0' : 'opacity-0 scale-75 rotate-45'"
      weight="duotone"
      size="24"
    />

    <!-- Sun Icon -->
    <ph-sun
      v-show="!isDarkMode"
      class="absolute m-auto text-yellow-600 inset-0 transition-all duration-150 ease-in-out"
      :class="!isDarkMode ? 'opacity-100 scale-100 rotate-0' : 'opacity-0 scale-75 rotate-45'"
      weight="duotone"
      size="24"
    />
  </button-navbar>
</template>

<style scoped></style>
